import React from 'react';
import { ReactComponent as FileDownload } from '../../../../assets/icons/file-download.svg';
import PropTypes from 'prop-types';
import './styles.scss';
import Moment from 'react-moment';
import l from '../../../../lang';
import ChipStatus from '../../../common/chip-status';
import { Urls } from '../../../../config/urls';
import { createDate, getMappedCountryCode } from '../../../../utils';
import { Button } from '../../../common/button';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const RefundDetail = ({ detail }) => {
  const exportToPDF = async () => {
    const element = document.getElementById('capture');
    const canvas = await html2canvas(element, {
      scale: 2,
      ignoreElements: element => {
        return element.classList.contains('no_export');
      },
    });

    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, width, height);
    pdf.save('refund-voucher.pdf');
  };

  return (
    <div className="refund-detail" id="capture">
      <div className="refund-detail__label-status">
        <ChipStatus status={detail.status} text={l(`refunds.status.${detail.status}`)} />
      </div>

      <div>
        <div className="refund-detail__item">
          <div className="refund-detail__subtitle">{l('refunds.date')}</div>
          <Moment format="DD/MM/YYYY">{createDate(detail.date)}</Moment>
        </div>
        <div className="refund-detail__item">
          <div className="refund-detail__subtitle">{l('refunds.time')}</div>
          <Moment format="hh:mm:ss a">{createDate(detail.date)}</Moment>
        </div>
      </div>
      <div>
        <div className="refund-detail__item">
          <div className="refund-detail__subtitle">{l('refunds.country')}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img
              alt={`img-country-${detail.country}`}
              className="refund-detail__country no_export"
              src={`${Urls.flags.replace(':code', getMappedCountryCode(detail.country))}`}
            />
            <span>{l(`countryCode.${detail.country}`)}</span>
          </div>
        </div>
        <div className="refund-detail__item">
          <div className="refund-detail__subtitle">{l('refunds.id')}</div>
          <div>{detail.id}</div>
        </div>
      </div>
      <div>
        <div className="refund-detail__item">
          <div className="refund-detail__subtitle">{l('refunds.transactionId')}</div>
          <div>{detail.transactionId}</div>
        </div>
        <div className="refund-detail__item">
          <div className="refund-detail__subtitle">{l('refunds.paymentMethod')}</div>
          <div>{detail.paymentMethod}</div>
        </div>
      </div>
      <div>
        <div className="refund-detail__item">
          <div className="refund-detail__subtitle">{l('refunds.localAmount')}</div>
          <div>
            {detail.currency} {detail.localAmount}
          </div>
        </div>
        <div className="refund-detail__item">
          <div className="refund-detail__subtitle">{l('refunds.balanceAmount')}</div>
          <div>
            {detail.balanceCurrency} {detail.balanceAmount}
          </div>
        </div>
      </div>
      <div>
        <div className="refund-detail__item">
          <div className="refund-detail__subtitle">{l('refunds.balanceFee')}</div>
          <div>
            {detail.balanceCurrency} {detail.balanceFee}
          </div>
        </div>
      </div>
      {/* <div className="no_export" style={{ marginBottom: 10, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          textTransformNone
          startIcon={<FileDownload />}
          size="small"
          style={{ backgroundColor: '#F5F5F5' }}
          color="primary"
          variant="outlined"
          onClick={exportToPDF}
        >
          Export to PDF
        </Button>
      </div> */}
    </div>
  );
};

RefundDetail.propTypes = {
  detail: PropTypes.object,
};

export default RefundDetail;
